import { render, staticRenderFns } from "./DatingReview.vue?vue&type=template&id=31d1a39e&scoped=true"
import script from "./DatingReview.vue?vue&type=script&lang=js"
export * from "./DatingReview.vue?vue&type=script&lang=js"
import style0 from "./DatingReview.vue?vue&type=style&index=0&id=31d1a39e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d1a39e",
  null
  
)

export default component.exports